/* ===========================================================================
   Metallbau Odenthal - Zusammenstellung als PDF herunterladen
   Version 1.0.0 - 16.08.2026

   AUSGELIEFERT IN: Theme "Version 2.05 / DeinMetallbauer.shop" (203762991436)
   als eigenes Asset assets/mo-angebot-pdf.js. Diese Datei hier ist die
   gepflegte Quelle.

   WAS
   Ein Knopf im Warenkorb erzeugt aus dem aktuellen Korb ein PDF: alle
   Positionen mit Bild, Maßen, Oberfläche, Befestigung und Preisen, dazu
   Firmenkopf, Datum und Referenznummer. Der Kunde kann es dem Chef, dem
   Vermieter oder der Versicherung vorlegen - der klassische Grund, warum bei
   Maßanfertigung nicht sofort gekauft wird.

   WARUM EIGENE DATEI (nicht custom.js)
   custom.js ist an vollen Arbeitstagen von mehreren Sitzungen umkämpft und
   traegt bereits sechs Bloecke; ein Syntaxfehler dort legt alle sechs lahm.
   Eine neue Datei kollidiert mit niemandem - dieselbe Begruendung wie bei
   snippets/mo-bildlupe.liquid und assets/mo-warenkorb-akzent.css.

   WARUM AN ZWEI STELLEN
   Auf die Warenkorbseite /cart fuehrt im Shop kein einziger klickbarer Weg:
   Das Symbol im Header hat zwar href="/cart", das Theme faengt den Klick aber
   ab und oeffnet die Schublade; der einzige Link in der Schublade
   ("Weiter einkaufen") steht auf display:none. Ein Knopf allein auf /cart
   wuerde deshalb nie jemand sehen. In der Schublade steht er als schmale
   Textzeile, damit er den Weg zur Kasse nicht verwaessert.

   TIMING UND LADELAST
   jsPDF (366 KB) wird ERST BEIM KLICK nachgeladen, nie beim Seitenaufbau -
   die mobile Leistungsbewertung liegt ohnehin nur bei 41. Der Klick-Listener
   haengt per Delegation am document, damit er das Neu-Rendern der Schublade
   nach jeder Mengenaenderung ueberlebt.

   MESSWERTE (16.08.2026, an Stefans echtem Warenkorb)
   - Bilder ohne &width=: 1,1 MB je PNG, PDF 1,8 MB. Mit &width=300 und
     Canvas-Umweg: 22 KB je Bild, PDF rund 100 KB.
   - Der Canvas-Weg ist bewusst gewaehlt, obwohl fetch() derzeit JPEG liefert:
     Shopify liefert an <img>-Tags WebP, und WebP kann jsPDF nicht. Canvas
     dekodiert und gibt JPEG zurueck - unabhaengig davon, was der Server
     schickt. CORS ist geprueft: access-control-allow-origin: *
   - Sonderzeichen sind byte-genau geprueft: € = 0x80, - = 0x96, x = 0xd7,
     ... = 0x85 in WinAnsi. Umlaute kommen durch. Kein Zeichenverlust.

   FALLSTRICKE
   - Der Preis der Position enthaelt den Optionsaufpreis bereits
     (Handlauf: price 48000 bei _cl_options_price 40000). Nicht addieren.
   - Eigenschaften mit _-Praefix sind App-Interna und gehoeren nicht ins PDF -
     derselbe Filter, den auch das Theme im Warenkorb benutzt.
   - Erst umbrechen, dann die Blockhoehe daraus ableiten. Wer die Hoehe
     schaetzt und hinterher kuerzt, verliert Text (traf beim ersten Entwurf
     "Sonstige Anmerkungen" und lange Produkttitel).
   =========================================================================== */
(function () {
  'use strict';

  if (window.MO_ANGEBOT_PDF) return;          // Snippet steht auf /cart zweimal
  window.MO_ANGEBOT_PDF = { version: '1.0.1' };   // 04.10.2026: Beschriftungen umbrechen

  /* --- Stammdaten -------------------------------------------------------
     Quelle: Impressum / AGB / Widerrufsbelehrung. NICHT die Kontakt-Policy -
     die nennt abweichend 9026013, welche richtig ist, ist ungeklaert.
     Ladungsfaehige Anschrift ist der Geschaeftssitz Ruppichteroth, nicht die
     Werkhalle Eitorf.

     ⚠️ Oben steht die MARKE (DeinMetallbauer.shop), unten der Rechtstraeger
     (Metallbau Odenthal). Der Kunde kauft im Shop, nicht bei der Firma - so
     schreibt es auch der Seitenfuss: "DeinMetallbauer.shop ist der Onlineshop
     von Metallbau Odenthal". Der Traeger MUSS aber im Dokument stehen:
     ladungsfaehige Anschrift und USt-IdNr. sind Pflichtangaben. */
  var FIRMA = {
    marke: 'DeinMetallbauer.shop',
    name: 'Metallbau Odenthal',
    inhaber: 'Inhaber: Stefan Odenthal',
    strasse: 'Junkerweg 3',
    ort: '53809 Ruppichteroth',
    telefon: '+49 2295 9026013',
    mail: 'service@deinmetallbauer.shop',
    ust: 'USt-IdNr.: DE337690783',
    hwk: 'Handwerkskammer zu Köln, Betriebsnummer 12219656',
    shop: 'www.deinmetallbauer.shop'
  };

  var JSPDF_URL = null;   // wird aus dem data-Attribut des Knopfes gelesen
  var AKZENT = [234, 91, 11];
  var GRAU = [110, 110, 110];
  var SCHWARZ = [26, 26, 26];
  var LINIE = [220, 220, 220];
  var R = 18, RR = 192, FUSS_Y = 272;

  /* --- Hilfsfunktionen -------------------------------------------------- */

  function euro(cent) {
    return (cent / 100).toLocaleString('de-DE', {
      minimumFractionDigits: 2, maximumFractionDigits: 2
    }) + ' €';
  }

  function z2(n) { return String(n).padStart(2, '0'); }

  function datumDe(d) {
    return z2(d.getDate()) + '.' + z2(d.getMonth() + 1) + '.' + d.getFullYear();
  }

  function referenz(d) {
    return 'MO-' + String(d.getFullYear()).slice(2) + z2(d.getMonth() + 1) +
      z2(d.getDate()) + '-' + z2(d.getHours()) + z2(d.getMinutes());
  }

  function eigenschaften(props) {
    var raus = [];
    if (!props) return raus;
    Object.keys(props).forEach(function (k) {
      if (k.charAt(0) === '_') return;
      var v = props[k];
      if (v === null || v === undefined || String(v).trim() === '') return;
      var wert = String(v);
      if (wert.indexOf('/uploads/') !== -1) wert = wert.split('/').pop();
      raus.push([String(k), wert]);
    });
    return raus;
  }

  /* Shopify skaliert serverseitig. Ohne diesen Parameter landen die Originale
     (1,1 MB je PNG) im Dokument. */
  function bildUrl(url, px) {
    if (!url) return url;
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + (px || 300);
  }

  /* --- Bilder ----------------------------------------------------------- */

  function bildLaden(url, px) {
    return new Promise(function (fertig) {
      var frist = setTimeout(function () { fertig(null); }, 6000);
      var bild = new Image();
      bild.crossOrigin = 'anonymous';
      bild.onload = function () {
        clearTimeout(frist);
        try {
          var breite = px || 300;
          var c = document.createElement('canvas');
          c.width = breite;
          c.height = Math.max(1, Math.round(breite * bild.naturalHeight / bild.naturalWidth));
          var ctx = c.getContext('2d');
          ctx.fillStyle = '#ffffff';                 // PNG-Transparenz wird sonst schwarz
          ctx.fillRect(0, 0, c.width, c.height);
          ctx.drawImage(bild, 0, 0, c.width, c.height);
          fertig({ daten: c.toDataURL('image/jpeg', 0.82), typ: 'JPEG' });
        } catch (e) {
          fertig(null);                              // getaintetes Canvas: ohne Bild weiter
        }
      };
      bild.onerror = function () { clearTimeout(frist); fertig(null); };
      bild.src = bildUrl(url, px || 300);
    });
  }

  function alleBilder(items) {
    var urls = [];
    items.forEach(function (i) {
      if (i.image && urls.indexOf(i.image) === -1) urls.push(i.image);
    });
    return Promise.all(urls.map(function (u) { return bildLaden(u, 300); }))
      .then(function (ergebnisse) {
        var karte = {};
        urls.forEach(function (u, i) { if (ergebnisse[i]) karte[u] = ergebnisse[i]; });
        return karte;
      });
  }

  /* Das Logo kommt aus dem Header des Shops, nicht aus einer Theme-Einstellung:
     In Dawn-Abkoemmlingen wie Theme ONE ist das Logo eine SECTION-Einstellung
     des Headers, kein settings.*-Wert - ueber das DOM ist es unabhaengig davon
     erreichbar, und der Header steht auf jeder Seite.
     600 px, weil das Logo im PDF 46 mm breit ist (rund 330 dpi). */
  function logoLaden() {
    var img = document.querySelector('.header__heading-logo, .header__heading img, header img[alt*="ogo"]');
    var quelle = img && (img.getAttribute('src') || img.currentSrc);
    if (!quelle) return Promise.resolve(null);
    if (quelle.indexOf('//') === 0) quelle = location.protocol + quelle;
    return bildLaden(quelle.split('&width=')[0], 600).then(function (b) {
      if (!b) return null;
      b.verhaeltnis = img.naturalWidth && img.naturalHeight
        ? img.naturalWidth / img.naturalHeight
        : 3.0;                                    // 2048x682 des aktuellen Logos
      return b;
    });
  }

  /* --- Seitenkopf und -fuss --------------------------------------------- */

  function kopf(doc, d, seite, logo) {
    var gesetzt = false;
    if (logo) {
      try {
        var breite = 42;
        doc.addImage(logo.daten, logo.typ, R, 9, breite, breite / (logo.verhaeltnis || 3));
        gesetzt = true;
      } catch (e) { /* Text-Fallback unten */ }
    }
    if (!gesetzt) {
      doc.setFont('helvetica', 'bold');
      doc.setFontSize(15);
      doc.setTextColor.apply(doc, SCHWARZ);
      doc.text(FIRMA.marke, R, 20);
    }

    doc.setFont('helvetica', 'normal');
    doc.setFontSize(8);
    doc.setTextColor.apply(doc, GRAU);
    [FIRMA.strasse + ' · ' + FIRMA.ort, FIRMA.telefon, FIRMA.mail]
      .forEach(function (zeile, i) { doc.text(zeile, RR, 14 + i * 4, { align: 'right' }); });

    doc.setDrawColor.apply(doc, AKZENT);
    doc.setLineWidth(0.8);
    doc.line(R, 24.5, RR, 24.5);

    if (seite > 1) {
      doc.setFontSize(8);
      doc.setTextColor.apply(doc, GRAU);
      doc.text('Zusammenstellung vom ' + datumDe(d) + ' (Fortsetzung)', R, 30);
    }
  }

  function fuss(doc, seite, gesamt) {
    doc.setDrawColor.apply(doc, LINIE);
    doc.setLineWidth(0.2);
    doc.line(R, FUSS_Y, RR, FUSS_Y);

    doc.setFont('helvetica', 'normal');
    doc.setFontSize(7);
    doc.setTextColor.apply(doc, GRAU);
    doc.text(FIRMA.marke + ' ist der Onlineshop von ' + FIRMA.name + ' · ' + FIRMA.inhaber, R, FUSS_Y + 5);
    doc.text(FIRMA.strasse + ' · ' + FIRMA.ort + ' · ' + FIRMA.telefon + ' · ' + FIRMA.mail, R, FUSS_Y + 9);
    doc.text(FIRMA.ust + ' · ' + FIRMA.hwk, R, FUSS_Y + 13);
    doc.text('Seite ' + seite + ' von ' + gesamt, RR, FUSS_Y + 13, { align: 'right' });
  }

  /* --- Das Dokument ----------------------------------------------------- */

  function bauen(jsPDFKlasse, cart, bilder, logo) {
    var d = new Date();
    var doc = new jsPDFKlasse({ unit: 'mm', format: 'a4', compress: true });
    var seite = 1;
    bilder = bilder || {};

    kopf(doc, d, seite, logo);

    var y = 38;
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(17);
    doc.setTextColor.apply(doc, SCHWARZ);
    doc.text('Ihre Zusammenstellung', R, y);

    y += 7;
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(9);
    doc.setTextColor.apply(doc, GRAU);
    doc.text('Vom ' + datumDe(d) + '   ·   Referenz ' + referenz(d), R, y);
    y += 10;

    var items = cart.items || [];
    var TX = R + 27;
    var PREIS_BREITE = 34;

    items.forEach(function (item, idx) {
      var eig = eigenschaften(item.properties);

      doc.setFont('helvetica', 'bold');
      doc.setFontSize(10.5);
      var titelZeilen = doc.splitTextToSize(String(item.product_title || item.title || ''), 129 - PREIS_BREITE);

      doc.setFont('helvetica', 'normal');
      doc.setFontSize(8.5);
      var namenBreite = 0;
      eig.forEach(function (e) { namenBreite = Math.max(namenBreite, doc.getTextWidth(e[0] + ':')); });
      namenBreite = Math.min(Math.max(namenBreite + 3, 22), 46);
      var wertBreite = RR - PREIS_BREITE - (TX + namenBreite);

      /* 04.10.2026: Auch die Beschriftung wird umbrochen. Die Spalte ist auf 46 mm
         gedeckelt, die Beschriftung lief aber ungekuerzt weiter und lag ueber dem Wert
         ("Befestigung (von außen gesehen: links – rechts):" ist 65 mm breit). Je
         Eigenschaft zaehlt die laengere Seite. -2.5 statt -3: die laengste Beschriftung
         soll nicht an Rundungsresten umbrechen, wenn die Spalte nicht gedeckelt ist. */
      var zeilen = eig.map(function (e) { return [doc.splitTextToSize(e[0] + ':', namenBreite - 2.5)]; });
      doc.setFont('helvetica', 'bold');
      zeilen.forEach(function (z, i) { z.push(doc.splitTextToSize(eig[i][1], wertBreite)); });
      var eigZeilen = zeilen.reduce(function (s, z) { return s + Math.max(z[0].length, z[1].length); }, 0) || 1;
      var hoehe = Math.max(24, titelZeilen.length * 5 + 3 + eigZeilen * 4.6);

      if (y + hoehe > FUSS_Y - 26) {
        doc.addPage();
        seite++;
        kopf(doc, d, seite, logo);
        y = 38;
      }

      var oben = y;

      var bild = bilder[item.image];
      if (bild) {
        try { doc.addImage(bild.daten, bild.typ, R, oben, 22, 22); } catch (e) { /* ohne Bild weiter */ }
      }

      doc.setFont('helvetica', 'bold');
      doc.setFontSize(10.5);
      doc.setTextColor.apply(doc, SCHWARZ);
      titelZeilen.forEach(function (z, i) { doc.text(z, TX, oben + 4 + i * 5); });

      doc.setFont('helvetica', 'normal');
      doc.setFontSize(8.5);
      doc.setTextColor.apply(doc, GRAU);
      doc.text(item.quantity + ' × ' + euro(item.final_price), RR, oben + 4, { align: 'right' });

      doc.setFont('helvetica', 'bold');
      doc.setFontSize(11);
      doc.setTextColor.apply(doc, SCHWARZ);
      doc.text(euro(item.final_line_price), RR, oben + 10.5, { align: 'right' });

      var ey = oben + titelZeilen.length * 5 + 3;
      doc.setFontSize(8.5);

      if (zeilen.length === 0) {
        doc.setFont('helvetica', 'italic');
        doc.setTextColor.apply(doc, GRAU);
        doc.text('Standardausführung', TX, ey);
        ey += 4.6;
      } else {
        zeilen.forEach(function (z) {
          doc.setFont('helvetica', 'normal');
          doc.setTextColor.apply(doc, GRAU);
          z[0].forEach(function (nz, i) { doc.text(nz, TX, ey + i * 4.6); });   // 04.10.2026: umbrochen
          doc.setFont('helvetica', 'bold');
          doc.setTextColor.apply(doc, SCHWARZ);
          z[1].forEach(function (wz, i) { doc.text(wz, TX + namenBreite, ey + i * 4.6); });
          ey += Math.max(z[0].length, z[1].length) * 4.6;
        });
      }

      y = Math.max(oben + hoehe, ey) + 2;

      if (idx < items.length - 1) {
        doc.setDrawColor.apply(doc, LINIE);
        doc.setLineWidth(0.2);
        doc.line(R, y, RR, y);
        y += 7;
      }
    });

    /* Summe */
    y += 6;
    if (y > FUSS_Y - 46) {
      doc.addPage();
      seite++;
      kopf(doc, d, seite, logo);
      y = 40;
    }

    doc.setDrawColor.apply(doc, AKZENT);
    doc.setLineWidth(0.6);
    doc.line(R, y, RR, y);
    y += 8;

    doc.setFont('helvetica', 'bold');
    doc.setFontSize(12);
    doc.setTextColor.apply(doc, SCHWARZ);
    doc.text('Zwischensumme', R, y);
    doc.setFontSize(14);
    doc.text(euro(cart.total_price), RR, y, { align: 'right' });

    y += 6;
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(8.5);
    doc.setTextColor.apply(doc, GRAU);
    doc.text('inkl. 19 % MwSt. · zzgl. Versandkosten', RR, y, { align: 'right' });

    /* Hinweise */
    y += 12;
    doc.setFillColor(247, 247, 247);
    doc.rect(R, y, RR - R, 26, 'F');
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(8.5);
    doc.setTextColor.apply(doc, SCHWARZ);
    doc.text('Hinweise', R + 4, y + 6);
    doc.setFont('helvetica', 'normal');
    doc.setTextColor.apply(doc, GRAU);
    [
      'Diese Zusammenstellung ist unverbindlich und kein Angebot im Rechtssinne. Preisstand: ' + datumDe(d) + '.',
      'Die Versandkosten werden erst im Bestellabschluss berechnet, da sie sich nach Gewicht und Maßen richten.',
      'Alle Maßangaben in Millimetern. Gefertigt wird nach Freigabe der Maßzeichnung.'
    ].forEach(function (h, i) { doc.text(h, R + 4, y + 12 + i * 4.4); });

    y += 34;
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(9);
    doc.setTextColor.apply(doc, SCHWARZ);
    doc.text('Fragen zur Zusammenstellung? ' + FIRMA.telefon + ' oder ' + FIRMA.mail, R, y);

    var gesamt = doc.getNumberOfPages();
    for (var s = 1; s <= gesamt; s++) {
      doc.setPage(s);
      fuss(doc, s, gesamt);
    }

    doc.setProperties({
      title: 'Zusammenstellung ' + referenz(d) + ' - ' + FIRMA.marke,
      author: FIRMA.marke,
      creator: FIRMA.shop
    });

    return { doc: doc, name: 'Zusammenstellung_DeinMetallbauer-shop_' + referenz(d) + '.pdf' };
  }

  /* --- jsPDF nachladen (erst beim Klick) -------------------------------- */

  var laedt = null;

  function jsPDFHolen() {
    if (window.jspdf && window.jspdf.jsPDF) return Promise.resolve(window.jspdf.jsPDF);
    if (laedt) return laedt;
    if (!JSPDF_URL) return Promise.reject(new Error('Pfad zu jsPDF fehlt'));

    laedt = new Promise(function (fertig, fehler) {
      var s = document.createElement('script');
      s.src = JSPDF_URL;
      s.onload = function () {
        if (window.jspdf && window.jspdf.jsPDF) fertig(window.jspdf.jsPDF);
        else fehler(new Error('jsPDF geladen, aber nicht gefunden'));
      };
      s.onerror = function () { laedt = null; fehler(new Error('jsPDF laedt nicht')); };
      document.head.appendChild(s);
    });
    return laedt;
  }

  /* --- Der Klick --------------------------------------------------------- */

  function knopfZustand(knopf, text, aktiv) {
    var beschriftung = knopf.querySelector('.mo-pdf-knopf__text');
    if (beschriftung) beschriftung.textContent = text;
    knopf.disabled = !aktiv;
    knopf.classList.toggle('mo-pdf-knopf--laeuft', !aktiv);
  }

  function erzeugen(knopf) {
    var urspruenglich = knopf.querySelector('.mo-pdf-knopf__text');
    urspruenglich = urspruenglich ? urspruenglich.textContent : 'Als PDF speichern';

    knopfZustand(knopf, 'PDF wird erstellt …', false);

    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart.items || cart.items.length === 0) throw new Error('leer');
        return Promise.all([jsPDFHolen(), alleBilder(cart.items), logoLaden()])
          .then(function (beides) {
            var ergebnis = bauen(beides[0], cart, beides[1], beides[2]);
            ergebnis.doc.save(ergebnis.name);
            knopfZustand(knopf, 'PDF gespeichert ✓', true);
            setTimeout(function () { knopfZustand(knopf, urspruenglich, true); }, 4000);
          });
      })
      .catch(function (e) {
        knopfZustand(knopf, e && e.message === 'leer' ? 'Warenkorb ist leer' : 'Hat nicht geklappt – bitte erneut', true);
        setTimeout(function () { knopfZustand(knopf, urspruenglich, true); }, 5000);
        if (window.console) console.warn('[mo-angebot-pdf]', e);
      });
  }

  /* Delegation am document: die Schublade wird nach jeder Mengenaenderung neu
     gerendert, ein Listener am Knopf selbst waere danach weg. */
  document.addEventListener('click', function (ev) {
    var knopf = ev.target.closest ? ev.target.closest('.mo-pdf-knopf') : null;
    if (!knopf) return;
    ev.preventDefault();
    if (knopf.disabled) return;
    if (!JSPDF_URL) JSPDF_URL = knopf.getAttribute('data-jspdf') || null;
    erzeugen(knopf);
  });

  window.MO_ANGEBOT_PDF.bauen = bauen;   // fuer Messungen von Hand
})();
